module.exports = __webpack_public_path__ + "img/image_case_6.6dd2792b.png";